var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.01,23.5c2.36,0,4.37-.83,6.02-2.48,1.65-1.65,2.48-3.66,2.48-6.03s-.83-4.37-2.48-6.02c-1.65-1.65-3.66-2.48-6.03-2.48s-4.37.83-6.02,2.48c-1.65,1.65-2.48,3.66-2.48,6.03s.83,4.37,2.48,6.02c1.65,1.65,3.66,2.48,6.03,2.48Zm-.02-2.9c-1.56,0-2.88-.55-3.96-1.64-1.08-1.09-1.63-2.42-1.63-3.98s.55-2.88,1.64-3.96c1.09-1.08,2.42-1.63,3.98-1.63s2.88.55,3.96,1.64c1.08,1.09,1.63,2.42,1.63,3.98s-.55,2.88-1.64,3.96c-1.09,1.08-2.42,1.63-3.98,1.63Zm.01,9.4c-4.87,0-9.27-1.38-13.2-4.15-3.93-2.77-6.87-6.38-8.8-10.85C1.93,10.53,4.87,6.92,8.8,4.15,12.73,1.38,17.13,0,22,0s9.27,1.38,13.2,4.15,6.87,6.38,8.8,10.85c-1.93,4.47-4.87,8.08-8.8,10.85s-8.33,4.15-13.2,4.15Zm0-3c4.04,0,7.75-1.09,11.13-3.28s5.96-5.09,7.73-8.73c-1.77-3.63-4.34-6.54-7.72-8.73-3.38-2.18-7.09-3.28-11.13-3.28s-7.75,1.09-11.13,3.28c-3.38,2.18-5.98,5.09-7.78,8.73,1.8,3.63,4.39,6.54,7.77,8.73,3.38,2.18,7.09,3.28,11.13,3.28Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4ce6ec4a7b2fa70f19d10acd9491b97b.svg";
export { ForwardRef as ReactComponent };